import styles from "./post-section.module.css";
import { useNavigate } from "react-router-dom";
import { IPostInsight } from "../../../interfaces/insightPost";

interface IProps {
  onHandlePages: any;
  postInfo: IPostInsight;
}

const PostSection = ({ onHandlePages, postInfo }: IProps) => {
  const navigate = useNavigate();

  const handleOnClickSobre = (newPage: string, link: string) => {
    onHandlePages(newPage);
    return navigate(link);
  };

  return (
    <section className={styles.post_section}>
      <div className={styles.post_div}>
        <img
          className={styles.post_img}
          src={postInfo.cover}
          alt="Imagem de postagem"
          loading="lazy"
        />
        <div className={styles.post_texts}>
          <h1 className={styles.post_title}>{postInfo.title}</h1>
          <span className={styles.line}></span>
          <p className={styles.post_paragraph}>{postInfo.description}</p>
          <button
            className={styles.btn_leiaMais}
            onClick={() =>
              handleOnClickSobre("INSIGHTS", `/insights/post/${postInfo._id}`)
            }
          >
            LEIA MAIS
          </button>
        </div>
      </div>
    </section>
  );
};

export default PostSection;
